import { Mode } from '../../Types/Qubit'

export const qubitPlacementsArgMock = {
  mode: Mode.LIVE,
  placementId: '1zGB-kBsSv66QAFIGyOdIg',
  attributes: {
    visitor: {
      id: 'hda1cajn5xk-0l6km4w9u-ojsi4kw',
      url:
        'https://www.myprotein.com/sports-nutrition/impact-whey-protein/10530943.html',
    },
    product: {
      id: '10530943',
      name: 'Impact Whey Protein',
      categories: [
        'Nutrition',
        'Protein Shakes & Protein Powders',
        'Whey Protein',
        ' Impact Whey Protein',
      ],
    },
    view: {
      currency: 'GBP',
      type: 'product',
      subtypes: [
        'Nutrition',
        'Protein Shakes & Protein Powders',
        'Whey Protein',
        ' Impact Whey Protein',
      ],
      language: 'en-gb',
    },
  },
  resolveVisitorState: true,
  recsPreFilter: false,
}

export const qubitPlacementsResponseMock = {
  content: {
    imageUrl:
      'https://dd6zx4ibq538k.cloudfront.net/static/images/5945/64c336f6e0df3d8c8a87060b0f8d6816_46_46.png',
    message:
      '<strong>Selling fast!</strong> Over 10,000 purchased in the last 48 hours',
  },
  callbackData:
    'TJJLc9owFIX3_RWes0pm5IdsS7bVFcmQQCGllBTSbjqOrYCCH4otGUKn_71DMu10e-6dcx_f-YUdBHLT1m7RNkY2xs21ckv5lNvKuGn8GCdl-ZQwtwyLMgWB6SEoT3gcp5QzykMCC4GdMboXvn84HLz6VXetkarxirb2e912pncbazplVNv4qtZ5YdzDTr66-r3RpwGLgiyOvJ2pKxB09j_PXCvvxT4q8-anq7yQtWxMD4IaAvPpegyCFgKLGQiMKiHwbwkQaHVW6On2yt1f9auB8-XoZnr7uiinWxAoDQHmhV4YZB4NIxDYHAJ37UlVVe4zL3AuHij96MxVY4_OMeU_eXzpjLSu5EY-zpTxWZR4EXcuZpP7uzlxKrWXzq0s9u2lc73r2lr6lAZe4AVe4Kzyp7xTPosSL-IgKFQJgck6nk6NTVZzZSx7WG2CzebzFgSdKiFAx3U5de38vrVfs3UW5-PJol6CQL4dt7PH9cvS1vc_3GIRDiY9zXR_AIF6K9f6e_Dl5tquJouxTtan4fCpXo7Or4EIvJSnLIyzmLE0S0LGCIr-rAeMYFdAmM5KguGMpMxpkT837Lh3g4rv6_iQWbd97lW8P08bGoiQM4K-gUhCAtlAxJygaCAowfA3PhHPspjSJCGoBgiaeFlKsH1n923kxkmWscilINjKASL6_eFPAAAA__8=',
  visitorId: 'hda1cajn5xk-0l6km4w9u-ojsi4kw',
}

export const qubitPlacementsUrgencyMessagingMock = {
  content: {
    imageUrl:
      'https://dd6zx4ibq538k.cloudfront.net/static/images/6050/63ad4d308c970a3ed7f92453e3627834_100_128.png',
    message:
      '<strong>Selling fast!</strong> Over 5,000 purchased in the last 48 hours',
  },
  callbackData:
    'dFJNU8M2FLz3V3j2BDOyLdmWHaunQAMxJKQQmtAT49gKEbEtYcsJgeG_d5JMPy69ad7bXe3s229sIJBbXbuFbqxsrJsb5ZZynfeVdZM1T9blKk1T9-NzUJcgsB0Ei5OEByxhjMWcoIfAxlrTCd_f7_defTCttlI1XqFrvzO6tZ3b9LZVVunGV7XJC-vuN_LgmjPQZ5SHNI1Cb2PrCgRt_x_N3Cjvo18pe9IzVV7IWja2A0ENgUm2GIFAQ2B2DwKrSgj8YwIERh0n7Ov2yt1edfNdHD8Ob7Lbw6zM3kCgDAQGsRcyLwi4lyQg6HMITPWXqqrc5x51LqZ5oRqru82vTtZYWTnTvHBmc-fFYfSV8dfk0hkaU8mlXN0r6_Mw8cLYubgfP08nxKnUVjq3stjqS-d60-pa-oxRj3rUo848X-et8nmYeGEMguLkd7yIssz2yXyibM9f5ku6XD4c_banNRvVZeb2k2fdP6WLNMpH41n9CAJ5WtcPLLW1Dp-vA313tXo56MUTPbKNVRDf-Dvx43v0aWSrZFPI7DeI_6cO-_JfFH5-CNT5L_Mn_f3mup-PZyOTLL52-7v6cXgMHoJ6g3jAgyiNOB-kScA5QdEd55QTbAoI2_aSYHc8eJmzIn9v-OfWpVW8raN92rv6vVPRdg-CXQMRpAFB10AMOIFsIHhIUDQQjGBnO4hzOWnAYh5QgmoHwRIvHRC8nZvxx9CNkjTloctA8CZ3EOHPL38FAAD__w==',
  visitorId: '8def7223-f205-4a46-958c-b32c88ac0a69',
}

export const qubitPlacementsRecommendationRailMock = {
  qubitPlacements: {
    content: {
      recs: [
        { id: '12088106' },
        { id: '10485098' },
        { id: '10530943' },
        { id: '12658366' },
      ],
    },
    callbackData:
      'dFJNU8M2FLz3V3j2BDOyLdmWHaunQAMxJKQQmtAT49gKEbEtYcsJgeG_d5JMPy69ad7bXe3s229sIJBbXbuFbqxsrJsb5ZZynfeVdZM1T9blKk1T9-NzUJcgsB0Ei5OEByxhjMWcoIfAxlrTCd_f7_defTCttlI1XqFrvzO6tZ3b9LZVVunGV7XJC-vuN_LgmjPQZ5SHNI1Cb2PrCgRt_x_N3Cjvo18pe9IzVV7IWja2A0ENgUm2GIFAQ2B2DwKrSgj8YwIERh0n7Ov2yt1edfNdHD8Ob7Lbw6zM3kCgDAQGsRcyLwi4lyQg6HMITPWXqqrc5x51LqZ5oRqru82vTtZYWTnTvHBmc-fFYfSV8dfk0hkaU8mlXN0r6_Mw8cLYubgfP08nxKnUVjq3stjqS-d60-pa-oxRj3rUo848X-et8nmYeGEMguLkd7yIssz2yXyibM9f5ku6XD4c_banNRvVZeb2k2fdP6WLNMpH41n9CAJ5WtcPLLW1Dp-vA313tXo56MUTPbKNVRDf-Dvx43v0aWSrZFPI7DeI_6cO-_JfFH5-CNT5L_Mn_f3mup-PZyOTLL52-7v6cXgMHoJ6g3jAgyiNOB-kScA5QdEd55QTbAoI2_aSYHc8eJmzIn9v-OfWpVW8raN92rv6vVPRdg-CXQMRpAFB10AMOIFsIHhIUDQQjGBnO4hzOWnAYh5QgmoHwRIvHRC8nZvxx9CNkjTloctA8CZ3EOHPL38FAAD__w==',
    visitorId: '8def7223-f205-4a46-958c-b32c88ac0a69',
  },
}

export const qubitBadgeTallyMock = {
  data: {
    placementContent: {
      content: {
        config: {
          counter: 'Transactions',
          max: 12,
          op: 'More than',
          threshold: 100,
          timeframe: 'In the last day',
        },
        content: {
          icon:
            'https://dd6zx4ibq538k.cloudfront.net/static/images/5945/894f9b4f2d37e72f8f5abc1d56d1955d_10_12.png',
          message: 'Most Popular',
        },
      },
      callbackData:
        'PJFNT-MwEIbv-yui9wSS7XzVCfGeqm4LqxYKhK_lgtzEad06cZo4FFjtf1-VFTvHZzQzeub9jQ0EpLM1LWzjVOOobDUtVSUH42ha8bQqV1mWUZdtig8QuB4iTNKUpxFPeRhlBAMENs61vfD9w-HA6ve2s07phhW29pvBddpp2_gr1bteGaO6nqqGrlfM6N6BoBsg8LVBtprth5V2n9OtkYWqVeN6ENQQWPx8mILAQmA5B4HTJQT-nwRBq4_kuvjY_Djb29tpsr8_i89VOS3nNyDQLQQ4i1gUZCyMYhAMEgKX9kMbI33OAu_kKQy_ewvdDG_e21nykoxOvXHbGvWoVnPtfB6nLE68k_nF3eWCeEbvlHeuip099SabztbKD8OABSxggZfLSnba53HK4gQEhS4hcGuuap3vqlxNupfDTObbavs4BkGnSwi4h2tzu86DfDZUCzUJqZlcFjcgUJ9y021Tu9nyV371Hig9mz0_L59mYxDoz7ZZmovDfL-9a_MH2rnX5_vAPh7dW4iA8SQaxXGSZFEcJlk8Iij6Iw84waaAcN2gCF6PoZYyLOS24W87Wn0Vtdtej3YHEKz_Pf9-TEdplvGYhiBYq1eI-M-3vwEAAP__',
      visitorId: 'hda1cajn5xk-fffffffff-ojsi4kw',
    },
  },
}
